
/**
 * **特殊召喚しようとする**（Issue #537）。
 *
 * 開く: `spsummoning`（まだ無効にされうる瞬間）。出る場所で魔法陣が開き、光の柱が立ち、
 * カードが降りてくる。成功した瞬間のアップは `summoned`（別のファイル）。
 *
 * 通常召喚（`summoning`）より**大きくゆったり**（輪を 1 枚多く、柱を太く）——
 * 旧 `components/fx` では 1 ファイルが `STYLE` の表で 3 種を分けていた。
 */
const COLOR = '#b86bff';

/** 状況ごとのファイル（`../effects/spsummoning_<variant>_effect.js`）が共有する組み立て（Issue #628。arcade はどの状況も同じ絵） */
export const spec = {
  label: '特殊召喚',
  color: COLOR,
  sounds: () => [{ at: 0, name: 'summon' }],

  /**
   * **素材召喚（シンクロ・融合・儀式）かどうかで見出しを変える**（Issue #538）。
   *
   * core はどれも `spsummoning` で出すので、**直前に素材が動いたか**で見分ける
   * （旧 `components/fx` の `_materialSummon.js` と同じ見分け方）。
   * **1 ファイル = 1 イベント**なので、種類の違いはこのファイルの中の分岐になる。
   */
  opens({ payload, history }) {
    if (!payload?.zone) return null;
    const mats = history.run('move', { until: ['new_phase', 'new_turn'], filter: (p) => p.isMaterial });
    return { ...payload, materials: mats.map((m) => m.payload), materialCount: mats.length };
  },

  layers: [
    {
      id: 'circle',
      label: '魔法陣',
      part: 'ring',
      at: { card: '{uid}', else: { zone: '{zone}' } },
      props: { color: COLOR, ticks: 12, tickLen: 0.08, width: 8 },
      tf: {
        scale: { keys: [{ ms: 120, value: 0.2 }, { ms: 560, value: 2.9, ease: 'ease_out' }, { ms: 1420, value: 2.9 }] },
        opacity: { keys: [{ ms: 120, value: 0 }, { ms: 300, value: 1 }, { ms: 1200, value: 1 }, { ms: 1420, value: 0 }] },
        rotation: { keys: [{ ms: 120, value: 0 }, { ms: 1420, value: 220 }] },
      },
    },
    {
      id: 'pillar',
      label: '光の柱',
      part: 'beam',
      parent: 'circle',
      props: { color: COLOR, core: 0.18 },
      tf: {
        rotation: 90,
        scale: { keys: [{ ms: 200, value: 0.2 }, { ms: 420, value: 0.9, ease: 'ease_out' }, { ms: 1000, value: 0.4 }] },
        opacity: { keys: [{ ms: 200, value: 0 }, { ms: 420, value: 0.9 }, { ms: 1000, value: 0 }] },
      },
    },
    {
      id: 'material',
      label: '素材の光',
      part: 'glow',
      for: 'materials',
      at: { zone: '{fromZone}', else: { zone: '{zone}' } },
      props: { color: COLOR },
      tf: {
        scale: { keys: [{ ms: 0, value: 0.6 }, { ms: 280, value: 1.6, ease: 'ease_out' }] },
        opacity: { keys: [{ ms: 0, value: 0.9 }, { ms: 380, value: 0 }] },
      },
    },
    {
      id: 'card',
      label: '降りてくるカード',
      part: 'card',
      at: { card: '{uid}', else: { zone: '{zone}' } },
      props: { code: '{code}', player: '{player}', glow: COLOR, glowW: 6 },
      tf: {
        // 行き過ぎてから戻って落ち着く（着地の重み）
        scale: { keys: [{ ms: 300, value: 1.6 }, { ms: 760, value: 0.92, ease: 'ease_out' }, { ms: 900, value: 1 }] },
        opacity: { keys: [{ ms: 300, value: 0 }, { ms: 420, value: 1 }, { ms: 1200, value: 1 }, { ms: 1420, value: 0 }] },
        y: { keys: [{ ms: 300, value: -260 }, { ms: 760, value: 0, ease: 'ease_out' }] },
      },
    },
  ],
};
